import React, { FC } from 'react';
import { IEvent } from 'entities/Events/Event.models';
import { EEventStatusLabel, EEventTypeLabel } from 'entities/Events/Event.enum';
import { AssessmentHistory } from 'entities/PatientMetrics/components';
import { IPatient } from 'entities/Patient/Patient.models';
import { PatientDetails } from 'entities/Patient/components';

interface IComponentProps {
  event: IEvent | null;
  patient: IPatient | null;
}

export const EventContent: FC<IComponentProps> = ({ event, patient }) => {
  return (
    <div className="event__content">
      <div className="mb-7 d-flex align-center justify-between">
        <div className="ff-medium fs-lg">{patient?.name}</div>

        <div className="d-flex direction-column align-end">
          <div className="mb-2">
            <span className="ff-medium fs-md color-grey">Status: </span>

            {event && <span className="ff-medium fs-md">{EEventStatusLabel[event.status]}</span>}
          </div>

          <div>
            <span className="ff-medium fs-md color-grey">Event Type: </span>

            {event && <span className="ff-medium fs-md">{EEventTypeLabel[event.type]}</span>}
          </div>
        </div>
      </div>

      <div className="mb-7">
        <PatientDetails patient={patient} ccdaLink={event?.ccdaLink} />
      </div>

      <AssessmentHistory patientId={patient?.id} />
    </div>
  );
};
